export const Sparkline = ({ data = [], width = 64, height = 20, up = true }) => {
  if (!data || data.length < 2) {
    return <div style={{ width, height }} className="flex items-center"><div className="h-px w-full bg-white/10" /></div>;
  }
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const step = width / (data.length - 1);
  const points = data
    .map((v, i) => `${(i * step).toFixed(1)},${(height - ((v - min) / range) * (height - 2) - 1).toFixed(1)}`)
    .join(" ");
  const stroke = up ? "#00FF66" : "#FF3366";
  const last = data[data.length - 1];
  const lx = (width).toFixed(1);
  const ly = (height - ((last - min) / range) * (height - 2) - 1).toFixed(1);
  return (
    <svg width={width} height={height} className="overflow-visible">
      <polyline points={points} fill="none" stroke={stroke} strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={lx} cy={ly} r="1.6" fill={stroke} />
    </svg>
  );
};

export default Sparkline;
